import { useCallback } from "react";
import { useElectronicsConfiguration } from "../context/ElectronicsConfigurationContext.tsx";
import { useMechanicsConfiguration } from "../context/MechanicsConfigurationContext.tsx";
import { useProject } from "../context/ProjectContext.tsx";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";


export const useHardwareDesignFiles = () => {
  const { handle, setError } = useMessageHandler();
  const { config: electronics } = useElectronicsConfiguration();
  const { config: mechanics } = useMechanicsConfiguration();
  const { project } = useProject();

  const getHardwareDesignFiles = useCallback(async () => {
    if (!mechanics || !electronics) {
      setError("Konfiguration ungueltig.");
      return;
    }
    await handle(async () => {
      const payload = {
        project: project,
        mechanics: mechanics,
        electronics: electronics,
      };
      const response = await apiJson.post("/design_files/hardware", payload, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = new Date().toISOString().slice(0, 10).replace(/-/g, '') + "_qdTest_" + project.name + "_HardwareDesignFiles.zip";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }, [handle, setError, project, mechanics, electronics]);

  return { getHardwareDesignFiles };
};
